import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { Box, Typography } from '@mui/material';

/**
 * Public referral landing page. Serve at e.g.
 * `{REFERRAL_BASE_URL}/rejoindre?referralCode=…` (`?r=` is also accepted).
 * `/join` redirects here with the same query string (legacy URLs).
 *
 * Apple App Site Association must not claim `/rejoindre` for the app if the same
 * host uses Universal Links for `/signup` — only `/signup` should open the app.
 */
const JoinReferralScreen = () => {
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();
  const [message, setMessage] = useState('Redirection vers le magasin d’applications…');

  useEffect(() => {
    const params = new URLSearchParams(queryString);
    const code = params.get('referralCode') || params.get('r') || '';
    const bid = params.get('bid') || 'com.drivio.mobile';
    const iosUrl = params.get('ios') || '';

    if (!code) {
      setMessage('Lien invalide (code de parrainage manquant).');
      return;
    }

    const clip = `drivio-referral:${code}`;
    // Best-effort only: clipboard writes require a user gesture in most browsers.
    if (navigator.clipboard?.writeText) {
      void navigator.clipboard.writeText(clip).catch(() => {});
    }

    const innerQuery = `referralCode=${encodeURIComponent(code)}`;
    const referrer = encodeURIComponent(innerQuery);
    const playUrl = `https://play.google.com/store/apps/details?id=${encodeURIComponent(bid)}&referrer=${referrer}`;

    const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
    const isIOS = /iphone|ipad|ipod/i.test(ua);

    if (isIOS) {
      if (!iosUrl || !/^https:\/\//i.test(iosUrl)) {
        setMessage("Configurez le paramètre ios= (URL App Store) dans le lien d'invitation.");
        return;
      }
      window.location.replace(iosUrl);
      return;
    }

    window.location.replace(playUrl);
  }, [queryString]);

  return (
    <Box
      sx={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        margin: 0,
        padding: 3,
        minHeight: '100vh',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        textAlign: 'center',
        bgcolor: '#fff',
        color: '#222',
      }}
    >
      <Typography id="msg" variant="body1" component="p" sx={{ margin: 0 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default JoinReferralScreen;
